import React, { useEffect, useState } from "react";
import { getWithdrawListApi } from "../utils/apiHandlers";
import { useSelector } from "react-redux";
import Pagination from "../components/Pagination";
import { BsFillStopCircleFill } from "react-icons/bs";
import { IoCheckmarkCircleSharp } from "react-icons/io5";

const WithdrwalHis = () => {
  const { jwt } = useSelector((state) => state.wallet);
  const [history, sethistory] = useState([]);
  const [page, setPage] = useState(1);
  const [loading, setLoading] = useState(true);

  async function fetchList(pgnumber) {
    setLoading(true);
    getWithdrawListApi(jwt, pgnumber)
      .then((res) => {
        console.log(res, " response");
        if (res?.status == 200) {
          sethistory(res?.data);
          setPage(res?.page);
        } else {
          sethistory([]);
        }
        setLoading(false);
      })
      .catch((e) => {
        setLoading(false);
        console.log(e);
      });
  }

  useEffect(() => {
    fetchList(page);
  }, []);

  return (
    <div className="container-fluid">
      <div className="card">
        <div className="card-body">
          <div className="mb-2">
            <h5 className="mb-0">Withdraw History</h5>
          </div>
          <div className="table-responsive">
            <table className="table border table-striped table-bordered text-nowrap">
              <thead className="thead-dark">
                <tr>
                  {/* Replace these headers with your actual data keys */}
                  <th>S.no</th>
                  <th>Withdraw Amount</th>
                  <th>Fee Amount</th>
                  <th>Total Amount</th>
                  <th>Tx.Hash</th>
                  <th>Status</th>
                  <th>Requested At</th>
                </tr>
              </thead>
              <tbody>
                {history?.length &&
                  history.map((request, index) => (
                    <tr key={index}>
                      <td>{index + 1}</td>
                      <td>{request?.amount}</td>
                      <td>{request?.fee}</td>
                      <td>{request?.total}</td>
                      <td>
                        {/* {request?.txHash?.startsWith("0x")
                          ? request?.txHash?.slice(0, 7) +
                            "..." +
                            request?.txHash.slice(-14)
                          : request?.txHash} */}
                        {request?.status === "rejected"
                          ? "Auto withdrawal Holded"
                          : "Auto withdrawal dispatched"}
                      </td>
                      <td
                        className={`${
                          request?.status === "rejected"
                            ? " text-danger"
                            : " text-success"
                        }`}
                      >
                        <span className=" mx-2">
                          {request?.status === "rejected" ? (
                            <BsFillStopCircleFill color="#ff2212" size={18} />
                          ) : (
                            <IoCheckmarkCircleSharp color="#33ff76" size={20} />
                          )}
                        </span>
                        <span>
                          {request?.status === "rejected"
                            ? "HOLD"
                            : "COMPLETED"}
                        </span>
                      </td>
                      <td>
                        {new Date(
                          request?.timestamp * 1000
                        ).toLocaleDateString()}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <Pagination
              page={page}
              callback={(p) => {
                if (!loading) fetchList(p);
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default WithdrwalHis;
